/**
 * Navigation 그룹 브릿지 React Query Options
 */

import { queryOptions } from '@tanstack/react-query'

import type { ActionRequest } from '@/lib/bridge/types'

import * as methods from './methods'

export const navigationQueryKeys = {
  all: ['bridge', 'navigation'] as const,
  openExternal: (params: ActionRequest<'Navigation', 'openExternal'>) =>
    [...navigationQueryKeys.all, 'openExternal', params] as const,
  openViewUrl: (params: ActionRequest<'Navigation', 'openViewUrl'>) =>
    [...navigationQueryKeys.all, 'openViewUrl', params] as const,
  openInAppBrowser: (params: ActionRequest<'Navigation', 'openInAppBrowser'>) =>
    [...navigationQueryKeys.all, 'openInAppBrowser', params] as const
}

export const navigationQueryOptions = {
  openExternal: (params: ActionRequest<'Navigation', 'openExternal'>) =>
    queryOptions({
      queryKey: navigationQueryKeys.openExternal(params),
      queryFn: () => methods.openExternal(params)
    }),
  openViewUrl: (params: ActionRequest<'Navigation', 'openViewUrl'>) =>
    queryOptions({
      queryKey: navigationQueryKeys.openViewUrl(params),
      queryFn: () => methods.openViewUrl(params)
    }),
  openInAppBrowser: (params: ActionRequest<'Navigation', 'openInAppBrowser'>) =>
    queryOptions({
      queryKey: navigationQueryKeys.openInAppBrowser(params),
      queryFn: () => methods.openInAppBrowser(params)
    })
}
